import { render, staticRenderFns } from "./MembershipsBlock.vue?vue&type=template&id=5b7b4254&"
import script from "./MembershipsBlock.vue?vue&type=script&lang=js&"
export * from "./MembershipsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports